/**
 * @description - Resolve the base URL of the APIM gateway (scheme + host, no
 * trailing slash). Prefers the configurable `REACT_APP_APIM_BASE_URL`; falls
 * back to the legacy `apim-unicornbox-${env}.azure-api.net` template so
 * environments that have not yet defined the new variable keep working.
 *
 * NOTE: This lives in its own import-free module (no `us.common/constants`,
 * no barrel) so it can be imported directly as `us.common/functions/getApimBaseUrl`
 * without pulling the `functions` barrel — which transitively imports `us.helper`
 * (via `handleEndPointLocals`) and would otherwise create a circular dependency
 * for `us.helper`'s HTTP clients that call this at module-eval time.
 * @returns {string} - APIM base URL, e.g. https://apim-unicornbox-dev.azure-api.net
 */
export const getApimBaseUrl = (): string =>
  window._ENV.REACT_APP_APIM_BASE_URL ??
  `https://apim-unicornbox-${window._ENV.REACT_APP_COLLECTION_API_ENV}.azure-api.net`;
